   
<template>
<div class="container loginPHH" v-if="!iswxCientOpen">

	<div v-if="!isMobileCheck">
		<header class="lmy-header lmy-header-w">
				<i class="iconfont icon-back" onclick="window.history.go(-1)"></i>
				用户登录
		</header>
		<div class="login-logo">
			<img src="./../../assets/img/lmyLogo.png" alt="" /> 
		</div>
		<!-- <div class="login-type">
			<label :class="!isMobileLogin?'active':''"  @click="isMobileLogin=!isMobileLogin;title='短信验证登录'">短信验证登录</label>
			<label :class="isMobileLogin?'active':''">账号登录</label>
		</div> -->

		<!-- 账号登录 -->
		<div class="login-form" v-if="isMobileLogin">
			<input type="text" v-model="userName" placeholder="请输入账号" />
			<input type="password" v-model="password" placeholder="请输入密码" />
		</div>
		<!-- 获取手机验证码 -->
		<div class="login-form" v-if="!isMobileLogin">
			<input type="text" v-model="tel"  maxlength="13" placeholder="请输入手机号" />
			<input type="text" v-model="Captcha"  maxlength="13" placeholder="请输入图片校验码" />
			<img :src="codeUrl" class="codeUrl" v-if="codeUrl" @click="getCodeUrl"/>
		</div>

		<div class="login-submit" v-if="isMobileLogin">
			<button @click="loginByMobile()">登录</button>
		</div>	
		<div class="login-submit" v-if="!isMobileLogin">
			<button @click="getCheckCode()">获取手机验证码</button>
		</div>
	</div>

	<!-- 手机验证号登录 -->
	<div v-if="isMobileCheck">
		<header class="lmy-header lmy-header-w">
		  <i class="iconfont icon-back" @click="isMobileCheck=!isMobileCheck"></i>
		  用户登录
		</header>
		<div class="login-logo">
			<h3>已发送短信验证码到</h3>
			<h6>+86 {{tel}}</h6>
		</div>
		<div class="login-form">
			<input type="text" v-model="checkCode" placeholder="请输入验证码" />
		</div>
		<div class="login-submit" >
			<button @click="loginByCode()">登录</button>
		</div>
	</div>
</div>

</template>
<script>
export default { 
	  data () {
	    return {
			isMobileLogin:false,
			isMobileCheck:false,
			tel:'',
			checkCode:'',
			mobile:'',
			regDataToken:'',
			TraceKey:'',
			Captcha:'',
			codeUrl:'',
			title:'用户登录',
			loginType:'',
			lastPageUrl:this.$route.query.path||this.dao.get('lastPageUrl'),
			iswxCientOpen:true

	    }
	  },
	  watch:{
	  	tel(val,oldVal){
	  		if(val.length<oldVal.length){
	  			return;
	  		}
	  		var tel=val;
	  		if(tel.length==3){
	  			tel+=' ';
	  			this.tel=tel;


	  		}else if(tel.length==8){
				tel+=' ';
				this.tel=tel;
	  		}

	  	}

	  },
	  methods:{
		  browserRedirect() {
				var system = { 
					win: false, 
					mac: false, 
					xll: false, 
					ipad: false
				}; 
				//检测平台  
				var p = navigator.platform; 
				system.win = p.indexOf("Win") == 0; 
				system.mac = p.indexOf("Mac") == 0; 
				system.x11 = (p == "X11") || (p.indexOf("Linux") == 0); 
				system.ipad = (navigator.userAgent.match(/iPad/i) != null) ? true : false; 
				//跳转语句，如果是手机访问就自动跳转到wap.baidu.com页面  
				if (system.win || system.mac || system.xll || system.ipad) { 
					this.$router.go(-5)
				} else { 
					var ua = navigator.userAgent.toLowerCase();  
					if(ua.match(/MicroMessenger/i)=="micromessenger") {  
						this.$router.go(-3)
					} else {  
						this.$router.push('/');
					}  
				}
			},
	  	    getCodeUrl(callback){
	  	    	this.Captcha='';
                this.getRequest({
                    url: this.Api.captcha + '?width=90&height=50'
                }).then(res => {
                    if (res) {
                        this.codeUrl = 'data:image/jpg;base64,'+res.Img;
                        this.regDataToken = res.Token;
                        this.TraceKey = res.TraceKey;
                    }
                });
            },
	  		getCheckCode(){

	  			var that=this;
	  			var tel=this.tel;
	  			tel=tel.replace(/\s/ig,'');
	  			if(!this.checkMobile(tel))return;

				if(!this.Captcha){
					this.error({title:'提示',content:'请输入图片验证码'});
					return;
				}
		
				var data ={
					"phone": tel,
					"Token": this.regDataToken,
					"Captcha": this.Captcha,
					"TraceKey": this.TraceKey,
				};
				this.postRequest({
					url:this.Api.getSMS, 
					params:data
				}).then(res => {
				    if(res&&res.IsSuccess){
				    	this.isMobileCheck=true;
							this.title='短信验证登录';
				    }else{
				    	this.error({title:'提示',content:res.Msg});
							this.getCodeUrl();
				    }
				});
	  	},

	  	//手机验证码登录
			loginByCode(){
				
				var that=this;
				var tel=this.tel;
	  		tel=tel.replace(/\s/ig,'');
	  		var WXToken=that.dao.get('WXToken');
				if(!this.checkCode){
					this.error({title:'登陆失败',content:'请输入验证码'});
					return;
				}
				var data ={
					"Mobile": tel,
	        "Code": this.checkCode,
	        "WXToken": WXToken,
	        "LoginType": "3"
				};
				that.text='中...';
				this.postRequest({
					url:this.Api.smslogin, 
					params:data
				}).then(res => {
					that.text='';
					if(res&&res.IsSuccess){
					    if(res.Result.AccessToken){
					    	//登陆成功后，保存登陆信息到本地localstorage
				    		that.dao.set('userInfo',JSON.stringify(res.Result));
				    		that.setHttpHeaders(res.Result.AccessToken);
				    		var url=this.dao.get('lastPageUrl')||'';
				    		if(url){
				    			that.$router.replace(url);
				    		}else{
				    			that.$router.replace('/');
				    		}
					    }
					}else{
							this.error({title:'登陆失败',content:'请重新输入'});
				    	// var protocol = window.location.protocol + '//';
			  			// var location=window.location.href;
							// window.location.href=protocol+'lmy.cnbooking.net/getWXCode.html?path=login'+'&url='+location;
				    }
				});
			},
	  	//微信自动登录
			loginByWX:function(code){
				var that=this;
				var share=localStorage.ShareToken||'';
				var data ={
					"share":share,
	                "Code": code,
	                "loginType": "2"
				};
				this.postRequest({
					url:this.Api.wxlogin, 
					params:data
				}).then(res => {
					that.text='';
				    if(res&&res.IsSuccess){
						that.setHttpHeaders(res.Result.AccessToken);
   						if(res.Result.NeedBindPhone){
   							that.dao.set('WXToken',res.Result.WXToken);
							that.$router.push('/bindUserPhoneNumber');
				    	}else{
				    		//登陆成功后，保存登陆信息到本地localstorage
				    		that.dao.set('userInfo',JSON.stringify(res.Result));
				    		
				    		var url=this.dao.get('lastPageUrl')||'';
				    		this.browserRedirect()
				    		// if(url&&(url.indexOf("frHotelDetails")>-1||url.indexOf("hotelDetails")>-1||url.indexOf("presaleDetails")>-1||url.indexOf("packageDetails")>-1)){
				    		// 	that.$router.push(url);
				    			
				    		// }else{
				    		// 	that.$router.push('/');
				    		// }
							
				    	}
						
				    }else{
				    	// var protocol = window.location.protocol + '//';
			  			// var location=window.location.href;
						// window.location.href=protocol+'lmy.cnbooking.net/getWXCode.html?path=login'+'&url='+location;
				    	
				    }
				});
			},
			//手机密码登录
			loginByMobile:function(){
				var that=this;
				if(!this.userName){
					this.error({title:'登陆失败',content:'请输入企业编号'});
					return;
				}
				if(!this.password){
					this.error({title:'登陆失败',content:'请输入密码'});
					return;
				}
				var data ={
					"userName": this.userName,
	                "password": this.password,
	                "grant_type": "password",
	                "loginType": "1"
				};
				that.text='中...';
				this.postRequest({
					url:this.Api.smslogin, 
					params:data
				}).then(res => {
					that.text='';
					if(res&&res.IsSuccess){
					    if(res.Result.AccessToken){
					    		//登陆成功后，保存登陆信息到本地localstorage
				    		that.dao.set('userInfo',JSON.stringify(res.Result));
				    		that.setHttpHeaders(res.Result.AccessToken);
				    		var url=this.dao.get('lastPageUrl')||'';
				    		console.log(url);
				    		if(url&&(url.indexOf("frHotelDetails")>-1||url.indexOf("hotelDetails")>-1||url.indexOf("presaleDetails")>-1||url.indexOf("packageDetails")>-1)){
				    			that.$router.push(url);
				    		}else{
				    			that.$router.push('/');
				    		}
					    }
					}else{
				    	var protocol = window.location.protocol + '//';
			  			var location=window.location.href;
			 			window.location.href = protocol+'lmy.cnbooking.net/getWXCode.html?path=login'+'&url='+location;
				    }
				});
			},
			toLogInWechat(){
			    //在微信中打开
			   	var code=this.$route.query.code;
			  	var protocol = window.location.protocol + '//';
			  	var location=window.location.href;
			  	// var path=this.$router.currentRoute.fullPath;
				if(!code){
			 		window.location.href = protocol+'lmy.cnbooking.net/getWXCode.html?path=login'+'&url='+location;
			 	}else {
					var isWXLoginNeed=this.isWXLoginNeed();
					
					if(isWXLoginNeed){
						this.loginByWX(code);
					}else{
						this.$router.push('/');
					}
			 	}
			}
	  },
	  mounted(){
	  		var isLogOut = this.$route.query.isLogOut||this.$route.query.islogTest||'';
				var GDflag = this.dao.get("GDflag")||''
				var isWechat = JSON.parse(this.dao.get("isWechat"))||false
	  		if(isLogOut||GDflag||!isWechat){
	  			this.iswxCientOpen=false;
	  			this.getCodeUrl();
	  			return;
	  		}else{
	  			this.toLogInWechat();
	  		}
		},
}
</script>
<style scoped>
	.login-reg-tag{
		position: absolute;
		right:12px;
		top:0px;
		font-size: 13px;
	}
 	.container{
 		padding: 10px 0;
 	}
 	.login-logo{
 		text-align: center;
 		margin:20% 0 15% 0;
 	}
 	.login-reg{
 		height: 50px;
 		line-height: 50px;
 		text-align: center;
 		background-color: #f5f5f5;
 		width:85%;
 		margin:15px auto;
 		font-size: 15px;
 		color:#32b16c;
 	}
 	.login-type{
 		display: flex;
 		justify-content: space-between;
 		flex-wrap:wrap;
 		margin:20px auto;
 		width: 66%;
 		font-size: 17px;
 	}
 	.login-type>label{
 		display: inline-block;
 		padding-bottom: 5px;
 		color:#999;
 	}

 	.login-type>.active{
 		color:#333;
 		border-bottom: 2px solid #32b16c;
 	}
 	.login-logo>img{
		display: inline;
 		width: 70px;
	}
	.login-form{
		width: 93%;
		margin: 0 auto;
		margin-bottom: 40px;
		position: relative;
	}
	.codeUrl{
		position: absolute;
		right: 0;
		top:1rem;
		height: 1rem;
	}
	.login-form>input{
		width: 100%;
		height: 1rem;
		padding:10px 0;
		line-height: 1rem;
		text-indent: 14px;
		font-size: 18px;
		letter-spacing: 2px;
		background-color: #fff;
		display: block;
		border-bottom: 1px solid #ccc;
	}
	.login-submit{
		margin-bottom: 30px;
		text-align: center;
	}
	.login-submit>button{
		width:93%;
		border-radius: 4px;
		border:0px;
		color:#fff;
		height: 50px;
		font-size: 16px;
		background-color: #32b16c
	}
	.login-submit>h5{
		font-size: 14px;
		color: #999999;
		margin:10px 0;
		font-weight: 400;
	}
	.login-logo>h3{
		font-size: 16px;
		line-height: 40px;
	}
	.login-submit>h5>a{
		text-decoration: underline;
		color:#32b16c;
		font-weight: 500;
	}
	.login-bottom-logo{
		text-align: center;
		margin-top: 77px;
	}
	.login-bottom-logo>img{
		width:270px;
	}
	.loginPHH input::-webkit-input-placeholder{
    	color:#999;
    	font-size: 16px;
	}
	.login-logo>h6{
		font-size: 22px;
	 	line-height: 40px;
	}

</style>


// WEBPACK FOOTER //
// src/components/usr/login.vue